// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5772e533","703":"aa37391b"}[chunkId] + ".chunk.js";
};